import { AppBar, Button, IconButton, makeStyles, Toolbar, Typography } from '@material-ui/core';
import { Menu } from "@material-ui/icons";
import clsx from 'clsx';
import React from 'react';
import { useDispatch } from 'react-redux';
import { logoutDispatcher } from '../../../redux/dispatchers/authDispatcher';
import icons from '../../../utils/icons';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    title: {
        flexGrow: 1,
        alignItems: "center",
        display: "flex",
    },
    icon: {
        height: "3rem",
        [theme.breakpoints.down("sm")]: {
            margin: 'auto',
        },
    }
}));

const Navbar = ({
    classes,
    openSidebar,
    setOpenSidebar
}) => {
    const navClasses = useStyles();
    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(logoutDispatcher())
    }

    return (
        <>
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: openSidebar,
                })}
                style={{
                    display: ((window.screen.width >= 600) || ((window.screen.width < 600) && !openSidebar)) ? 'block' : 'none'
                }}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={setOpenSidebar}
                        edge="start"
                        className={clsx(classes.menuButton, {
                            [classes.hide]: openSidebar,
                        })}
                    >
                        <Menu color='primary' />
                    </IconButton>
                    <Typography variant="h6" noWrap className={navClasses.title}>
                        <img
                            src={icons.LogoHSvg}
                            alt="Hoichoi"
                            className={navClasses.icon}
                        />
                    </Typography>
                    <Button color="primary" onClick={handleLogout}>Logout</Button>
                </Toolbar>
            </AppBar>
        </>
    )
}

export default Navbar
